export const genres = {
  ACTION: 'action',
  ADVENTURE: 'adventure',
  ANIMATION: 'animation',
  AFRICAN: 'african',
  AFRICAN_AMERICAN: 'african-american',
  ASIAN: 'asian',
  ASIAN_AMERICAN: 'asian-american',
  BLACK: 'black',
  BUDDHIST: 'buddhist',
  BIOGRAPHY: 'biography',
  CHILDREN: 'children',
  CHRISTIAN: 'christian',
  COMEDY: 'comedy',
  CRIME: 'crime',
  DIY: 'diy',
  DEVELOPING_NATIONS: 'developing-nations',
  DISABILITY_CULTURE: 'disability-culture',
  DOCUMENTARY: 'documentary',
  DRAMA: 'drama',
  EDUCATION: 'education',
  FAMILY: 'family',
  FANTASY: 'fantasy',
  FILM_NOIR: 'film-noir',
  GAME_SHOW: 'game-show',
  HISPANIC: 'hispanic',
  HISTORY: 'history',
  HORROR: 'horror',
  INSTRUCTIONAL: 'instructional',
  ISLAMIC: 'islamic',
  JEWISH: 'jewish',
  LGBTQ: 'lgbtq',
  LATINO: 'latino',
  MATURE_ADULT: 'mature-adult',
  MUSIC: 'music',
  MUSICAL: 'musical',
  MYSTERY: 'mystery',
  NEWS: 'news',
  NATIVE_AMERICAN: 'native-american',
  NATIVE_ABORIGINAL_PEOPLE: 'native-aboriginal-people',
  PERSONAL: 'personal',
  REALITY_TV: 'reality-tv',
  ROMANCE: 'romance',
  SCI_FI: 'sci-fi',
  SENIOR_AGING: 'senior-aging',
  SPORT: 'sport',
  STUDENT: 'student',
  TALK_SHOW: 'talk-show',
  THRILLER: 'thriller',
  WAR: 'war',
  WESTERN: 'western',
  WOMEN: 'women',
  YOUTH_TEEN: 'youth-teen',
};


export default _.values(genres);

export const popular = [
  genres.ACTION,
  genres.ADVENTURE,
  genres.ANIMATION,
  genres.BIOGRAPHY,
  genres.CHILDREN,
  genres.COMEDY,
  genres.CRIME,
  genres.INSTRUCTIONAL,
  genres.DOCUMENTARY,
  genres.DRAMA,
  genres.EDUCATION,
  genres.FAMILY,
  genres.FANTASY,
  genres.HISTORY,
  genres.HORROR,
  genres.MUSIC,
  genres.MUSICAL,
  genres.MYSTERY,
  genres.NEWS,
  genres.PERSONAL,
  genres.REALITY_TV,
  genres.ROMANCE,
  genres.SCI_FI,
  genres.SPORT,
  genres.TALK_SHOW,
  genres.THRILLER,
  genres.WAR,
  genres.WESTERN,
];



// WEBPACK FOOTER //
// ./src/shared/constants/genres.js